import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { formatoFechas } from "../functions/funciones";
import { createDocsSupp, updateDocsSupp, validateDocsSupp, actualizarNoProcedeDoc } from "../services/docs.service";
import React from "react";
import { createRoot } from "react-dom/client";
import Switch from "@mui/material/Switch";
import { styled, alpha } from "@mui/material/styles";
import i18n from "../i18n";

import {
  createDeclRes,
  updateDeclRes,
  validateDeclRes,
} from "../services/declRes.service";

const t = (key) => i18n.t(key, { ns: 'common' });

const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    color: "#FF5252",
    "&:hover": {
      backgroundColor: alpha("#FF5252", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
    backgroundColor: "#FF5252",
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#7bc977",
    backgroundColor: alpha("#7bc977", theme.palette.action.hoverOpacity),
    "&:hover": {
      backgroundColor: alpha("#7bc977", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#7bc977",
  },
}));

export const subirDocumentacionProveedor = async (
  ruta,
  id,
  idDoc,
  rol,
  nif,
  noProcede = false
) => {
  return new Promise(async (resolve, reject) => {
    try {
      var el = document.getElementById("fileElem");
      let toastInfo = undefined;
      let noProcedeValue = noProcede;
      const rolesNoProcede = ["ADMIN", "CONSUL", "VENT"];
      const esRLCoRNT = idDoc === 8 || idDoc === 9;
      const puedeVerNoProcede = rolesNoProcede.includes(rol) && esRLCoRNT;

      const swalConfig = {
        title: t('documents.uploadDocumentation') + "<br/>",
        showCancelButton: true,
        confirmButtonText: t('documents.saveAndChooseFile'),
        confirmButtonColor: "rgb(130, 130, 130)",
        cancelButtonText: t('actions.cancel'),
        customClass: {
          actions: "my-actions",
          cancelButton: "order-1 right-gap",
          confirmButton: "order-3",
        },
        focusConfirm: false,
      };

      let htmlContent = '';

      // Agregar switch de No procede para RLC y RNT si el rol tiene permiso
      if (puedeVerNoProcede) {
        htmlContent += `
          <div style="display: flex; align-items: center; justify-content: center; margin: 15px 0; gap: 10px;">
            <span style="font-weight: 500; font-size: 14px;">${t('documents.notApplicable')}</span>
            <div id="switch-mount-subir"></div>
          </div>
          <div id="upload-section">
        `;
      }

      if (idDoc !== 1 && idDoc !== 5 && idDoc !== 6 && idDoc !== 8 && idDoc !== 9 && idDoc !== 10) {
        htmlContent += `<div><p>${t('documents.indicateExpirationDate')}</p><input type="date" id="fecha" style="margin: 20px 0" class="swal2-input"></div>`;
      }

      if (puedeVerNoProcede) {
        htmlContent += '</div>';
      }

      if (htmlContent) {
        swalConfig.html = htmlContent;
      }

      if (puedeVerNoProcede) {
        swalConfig.didOpen = () => {
          const switchMount = document.getElementById('switch-mount-subir');
          const uploadSection = document.getElementById('upload-section');
          const confirmBtn = Swal.getConfirmButton();

          if (switchMount) {
            const root = createRoot(switchMount);

            const SwitchComponent = () => {
              const [checked, setChecked] = React.useState(noProcedeValue);

              const handleChange = (e) => {
                const newValue = e.target.checked;
                setChecked(newValue);
                noProcedeValue = newValue;

                // Actualizar UI
                if (newValue) {
                  if (uploadSection) uploadSection.style.display = 'none';
                  confirmBtn.textContent = t('actions.save');
                } else {
                  if (uploadSection) uploadSection.style.display = 'block';
                  confirmBtn.textContent = t('documents.saveAndChooseFile');
                }
              };

              return React.createElement(CustomSwitch, {
                checked: checked,
                onChange: handleChange
              });
            };

            root.render(React.createElement(SwitchComponent));

            if (noProcedeValue) {
              if (uploadSection) uploadSection.style.display = 'none';
              confirmBtn.textContent = t('actions.save');
            }
          }
        };
      }

      Swal.fire({
        ...swalConfig,
        focusConfirm: false,
        preConfirm: () => {
          if (puedeVerNoProcede && noProcedeValue) {
            return { noProcede: true };
          }

          let fecha = null;
          if (idDoc !== 1 && idDoc !== 5 && idDoc !== 6 && idDoc !== 8 && idDoc !== 9 && idDoc !== 10) {
            fecha = formatoFechas(
              Swal.getPopup().querySelector("#fecha").value
            );
            if (!fecha || isNaN(new Date(fecha).getTime())) {
              Swal.showValidationMessage(t('documents.expirationDate'));
            }
          }
          else if (idDoc === 6 || idDoc === 8 || idDoc === 9){
              const fechaActual = new Date();

              fechaActual.setDate(fechaActual.getDate() + 90);
              fecha = formatoFechas(fechaActual);
          }
          const data = {
            tipoDoc: idDoc,
            fechaCaducidad: fecha,
            pendiente:
              rol === "ADMIN" || rol === "CONSUL" || rol === "TECH" || rol === "TECH_COOR" || rol === "VENT"
                ? false
                : true,
            avisado: false,
            segundoAviso: false,
            validado:
              rol === "ADMIN" || rol === "CONSUL" || rol === "TECH" || rol === "TECH_COOR" || rol === "VENT"
                ? true
                : false,
          };
          return { data: data, noProcede: false };
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (result.value.noProcede) {
            toastInfo = toast.info(t('documents.updatingStatus'), { autoClose: false });
            try {
              await actualizarNoProcedeDoc(nif, idDoc, true);
              toast.update(toastInfo, {
                render: t('documents.statusUpdatedSuccess'),
                type: toast.TYPE.SUCCESS,
                autoClose: true,
              });
              resolve(true);
            } catch (err) {
              console.log(err);
              toast.update(toastInfo, {
                render: t('documents.statusUpdateError'),
                type: toast.TYPE.ERROR,
                autoClose: true,
              });
            }
            return;
          }

          el.click();
          el.onchange = () => {
            toastInfo = toast.info(t('documents.savingData'), { autoClose: false });

            const uploadPromise = id
              ? updateDocsSupp(el.files[0], nif, id, result.value.data)
              : createDocsSupp(el.files[0], nif, result.value.data);

            uploadPromise
              .then((res) => {
                toast.update(toastInfo, {
                  render: t('documents.fileUpdatedSuccess'),
                  type: toast.TYPE.SUCCESS,
                  autoClose: true,
                });

                const importResult = res?.data?.importTrabajadores;
                if (importResult) {
                  const correctos = importResult.correctos || 0;
                  const erroneos = importResult.erroneos || [];

                  let htmlContent = `<div style="text-align:left;font-size:14px;">`;
                  htmlContent += `<p style="color:#7bc977;font-weight:bold;">✓ ${correctos} ${t('documents.workersImportedCorrectly')}</p>`;
                  if (erroneos.length > 0) {
                    htmlContent += `<p style="color:#ff5252;font-weight:bold;margin-top:10px;">✗ ${erroneos.length} ${t('documents.workersWithErrors')}:</p>`;
                    htmlContent += `<ul style="margin-top:5px;max-height:200px;overflow-y:auto;">`;
                    erroneos.forEach(err => {
                      htmlContent += `<li style="margin-bottom:4px;">${err}</li>`;
                    });
                    htmlContent += `</ul>`;
                  }
                  htmlContent += `</div>`;

                  Swal.fire({
                    title: t('documents.workersImportResult'),
                    html: htmlContent,
                    icon: erroneos.length > 0 ? 'warning' : 'success',
                    confirmButtonColor: '#92004d',
                  });
                }

                resolve(importResult ? { importTrabajadores: importResult } : true);
              })
              .catch((err) => {
                console.log(err);
                toast.update(toastInfo, {
                  render: t('documents.fileUpdateError'),
                  type: toast.TYPE.ERROR,
                  autoClose: true,
                });
              });
          };
        }
      });
    } catch (error) {
      reject(error);
    }
  });
};

export const subirDocumentacionPerfilProveedor = async (
  ruta,
  id,
  idDoc,
  rol,
  nif
) => {
  //creamos todo dentro de un promise para que cuando acabe de subirse se actualice la info en la vista sin necesidad de recargar pagina
  return new Promise(async (resolve, reject) => {
    try {
      // await new Promise((resolve) => setTimeout(resolve, 200));
      var el = document.getElementById("fileElem");
      let toastInfo;
      const data = {
        tipoDoc: idDoc,
        pendiente:
          rol === "ADMIN" || rol === "CONSUL" || rol === "TECH" || rol === "TECH_COOR" || rol === "VENT" ? false : true,
        avisado: false,
        segundoAviso: false,
        validado:
          rol === "ADMIN" || rol === "CONSUL" || rol === "TECH" || rol === "TECH_COOR" || rol === "VENT" ? true : false,
      };
      el.click();
      el.onchange = () => {
        toastInfo = toast.info(t('documents.savingData'), { autoClose: false });
        const uploadPromise = id
          ? updateDocsSupp(el.files[0], nif, id, data)
          : createDocsSupp(el.files[0], nif, data);

        uploadPromise
          .then((res) => {
            toast.update(toastInfo, {
              render: t('documents.fileUpdatedSuccess'),
              type: toast.TYPE.SUCCESS,
              autoClose: true,
            });
            resolve(true);
          })
          .catch((err) => {
            console.log(err);
            toast.update(toastInfo, {
              render: t('documents.fileUpdateError'),
              type: toast.TYPE.ERROR,
              autoClose: true,
            });
          });
      };
    } catch (error) {
      // En caso de error, rechaza la promesa
      reject(error);
    }
  });
};

export const subirDocumentacionCentroTrabajo = (
  nombreDoc,
  finca,
  nifCentroTrabajo,
  callback
) => {};

export const subirDocumentacionComunidad = (nombreDoc, finca, callback) => {};

export const abrirArchivo = async (ruta) => {
  if (!ruta) {
    // toast.error("No existe el archivo")
    return;
  } else {
    try {
      const url = `${process.env.REACT_APP_STORAGE_URL}${ruta}`;
      console.log(url);
      window.open(url, "_blank");
    } catch (error) {
      console.log(error);
      toast.error(t('documents.fileDownloadError'));
    }
  }
};

export const verDocumentacion = (ruta, id, idDoc, rol, nif, noProcede = false) => {
  //creamos todo dentro de un promise para que cuando acaben las funciones se actualice la info en la vista sin necesidad de recargar pagina
  return new Promise(async (resolve, reject) => {
    try {
      const rolesNoProcede = ["ADMIN", "CONSUL", "VENT"];
      const esRLCoRNT = idDoc === 8 || idDoc === 9;
      const puedeVerNoProcede = rolesNoProcede.includes(rol) && esRLCoRNT;
      let noProcedeValue = false;

      const swalConfig = {
        title: t('documents.whatDoYouWant'),
        text: " " + t('documents.overwriteWarning'),
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: t('actions.view'),
        confirmButtonColor: "rgb(130, 130, 130)",
        denyButtonText: t('documents.overwrite'),
        denyButtonColor: "rgb(130, 130, 130)",
        cancelButtonText: t('documents.deleteDocument'),
        cancelButtonColor: "#892828",
        customClass: {
          actions: "my-actions",
          cancelButton: "order-1 right-gap",
          confirmButton: "order-3",
          denyButton: "order-2",
        },
        focusConfirm: false,
      };

      // Agregar switch de No procede para RLC y RNT si el rol tiene permiso
      if (puedeVerNoProcede) {
        swalConfig.html = `
          <p style="margin-bottom: 15px;">${t('documents.overwriteWarning')}</p>
          <div style="display: flex; align-items: center; justify-content: center; margin-top: 15px">
            <span style="font-weight: 500; font-size: 14px;">${t('documents.notApplicable')}</span>
            <div id="switch-mount-ver"></div>
          </div>
        `;

        swalConfig.didOpen = () => {
          const switchMount = document.getElementById('switch-mount-ver');
          const confirmBtn = Swal.getConfirmButton();
          const denyBtn = Swal.getDenyButton();
          const cancelBtn = Swal.getCancelButton();

          if (switchMount) {
            const root = createRoot(switchMount);

            const SwitchComponent = () => {
              const [checked, setChecked] = React.useState(false);

              const handleChange = (e) => {
                const newValue = e.target.checked;
                setChecked(newValue);
                noProcedeValue = newValue;

                if (newValue) {
                  denyBtn.style.display = 'none';
                  cancelBtn.style.display = 'none';
                  confirmBtn.textContent = t('actions.save');
                } else {
                  denyBtn.style.display = '';
                  cancelBtn.style.display = '';
                  confirmBtn.textContent = t('actions.view');
                  confirmBtn.style.backgroundColor = 'rgb(130, 130, 130)';
                }
              };

              return React.createElement(CustomSwitch, {
                checked: checked,
                onChange: handleChange
              });
            };

            root.render(React.createElement(SwitchComponent));
          }
        };
      }

      Swal.fire(swalConfig).then(async (result) => {
        if (result.isConfirmed) {
          if (puedeVerNoProcede && noProcedeValue) {
            const toastInfo = toast.info(t('documents.updatingStatus'), { autoClose: false });
            try {
              await actualizarNoProcedeDoc(nif, idDoc, true);
              toast.update(toastInfo, {
                render: t('documents.statusUpdatedSuccess'),
                type: toast.TYPE.SUCCESS,
                autoClose: true,
              });
              resolve(true);
            } catch (err) {
              console.log(err);
              toast.update(toastInfo, {
                render: t('documents.statusUpdateError'),
                type: toast.TYPE.ERROR,
                autoClose: true,
              });
            }
            return;
          }
          abrirArchivo(ruta);
        } else if (result.isDenied) {
          const subirDocPromise = subirDocumentacionProveedor(
            ruta,
            id,
            idDoc,
            rol,
            nif,
            noProcede
          );
          subirDocPromise.then(resolve).catch(reject);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          const deleteDocPromise = validateDocsSupp(nif, id, {
            validado: false,
          });
          deleteDocPromise
            .then(resolve)
            .then(toast.success(t('documents.documentDeletedSuccess')))
            .catch(reject);
        }
      });
    } catch (error) {
      reject(error);
    }
  });
};
export const validarDocumentacion = (ruta, id, nif,idtypeDoc) => {
  return new Promise(async (resolve, reject) => {
    try {
      let toastInfo = undefined;
      abrirArchivo(ruta);
      const swalConfig = {
        title: t('documents.whatDoYouWant'),
        text: " " + t('documents.notValidatedWarning'),
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: t('documents.validate'),
        confirmButtonColor: "#7bc977",
        denyButtonText: t('documents.notValidate'),
        denyButtonColor: "#FF5252",
        cancelButtonText: t('actions.cancel'),
        customClass: {
          actions: "my-actions",
          confirmButton: "order-3",
          denyButton: "order-2",
        },
        focusConfirm: false,
      };
      if (idtypeDoc !== 1 && idtypeDoc !== 5 && idtypeDoc !== 6 && idtypeDoc !== 8 && idtypeDoc !== 9 && idtypeDoc !== 10) {
        swalConfig.html =
          `<div><p>${t('documents.indicateExpirationDate')}</p><input type="date" id="fecha" style="margin: 20px 0" class="swal2-input"></div>`;
      }
      Swal.fire({
        ...swalConfig,
        preConfirm: () => {
          let fecha = null;
          if (idtypeDoc !== 1 && idtypeDoc !== 5 && idtypeDoc !== 6 && idtypeDoc !== 8 && idtypeDoc !== 9 && idtypeDoc !== 10) {
            fecha = formatoFechas(
              Swal.getPopup().querySelector("#fecha").value
            );
          }

          if (idtypeDoc !== 1 && idtypeDoc !== 5 && idtypeDoc !== 6 && idtypeDoc !== 8 && idtypeDoc !== 9 && idtypeDoc !== 10) {
            if (!fecha || isNaN(new Date(fecha).getTime())) {
              Swal.showValidationMessage(t('documents.expirationDate'));
            }
          }
          if (idtypeDoc === 6 || idtypeDoc === 8 || idtypeDoc === 9){
            const fechaActual = new Date();
                          console.log("bbbb", fechaActual)
            fechaActual.setDate(fechaActual.getDate() + 90);
            fecha = formatoFechas(fechaActual);
          }
                      console.log("ccccc", idtypeDoc)
          const data = {
            fechaCaducidad: fecha,
            validado: true,
          };
          return { data: data };
        },
      }).then((result) => {
        if (result.isConfirmed) {
          toastInfo = toast.info(t('documents.savingData'), { autoClose: false });
          validateDocsSupp(nif, id, result.value.data)
            .then((res) => {
              toast.update(toastInfo, {
                render: t('documents.fileValidatedSuccess'),
                type: toast.TYPE.SUCCESS,
                autoClose: true,
              });
              resolve(true);
            })
            .catch((err) => {
              console.log(err);
              toast.update(toastInfo, {
                render: t('documents.fileValidationError'),
                type: toast.TYPE.ERROR,
                autoClose: true,
              });
            });
        } else if (result.isDenied) {
          validateDocsSupp(nif, id, result.value.data)
            .then((res) => {
              // toast.update(toastInfo, {
              //   render: "El archivo se ha validado correctamente",
              //   type: toast.TYPE.SUCCESS,
              //   autoClose: true
              // });
              resolve(true);
            })
            .catch((err) => {
              console.log(err);
              // toast.update(toastInfo, {
              //   render: "Error al validar el archivo",
              //   type: toast.TYPE.ERROR,
              //   autoClose: true
              // });
            });
        }
      });
    } catch (error) {
      reject(error);
    }
  });
};

export const borrarArchivo = (ruta) => {
  // Por hacer
};

export const subirDeclaracionResponsable = async (
  nifProv,
  idAAFF,
  ruta,
  idDeclRes,
  showAlert
) => {
  // //new
  // try {
  //   console.log(nifProv, idAAFF, ruta, idDeclRes);

  //   const result = await showAlert({
  //     title: "Subir declaración responsable",
  //     confirmButtonText: "Guardar  y elegir archivo",
  //     cancelButtonText: "Cancelar",
  //     confirmButtonColor:"rgb(130, 130, 130)",
  //     preConfirm: () => {
  //       const data = { aaff_id: idAAFF };
  //       return data;
  //     },
  //   });

  //   if (result.isConfirmed) {
  //     console.log(result);

  //   }

  // } catch (error) {
  //   console.log(error);
  // }

  //creamos todo dentro de un promise para que cuando acabe de subirse se actualice la info en la vista sin necesidad de recargar pagina
  return new Promise(async (resolve, reject) => {
    try {
      // await new Promise((resolve) => setTimeout(resolve, 200));
      var el = document.getElementById("fileElem");
      let toastInfo = undefined;
      Swal.fire({
        title: t('documents.uploadResponsibleDeclaration'),
        showCancelButton: true,
        confirmButtonText: t('documents.saveAndChooseFile'),
        confirmButtonColor: "rgb(130, 130, 130)",
        cancelButtonText: t('actions.cancel'),
        customClass: {
          actions: "my-actions",
          cancelButton: "order-1 right-gap",
          confirmButton: "order-3",
        },
        focusConfirm: false,
        preConfirm: () => {
          const data = {
            aaff_id: idAAFF,
          };
          return { data: data };
        },
      }).then((result) => {

        if (result.isConfirmed) {
          //si se le da al boton de guardar

          el.click();
          el.onchange = () => {

            if (idDeclRes === undefined) {
              //si no hay ruta se sube la documentación y si ya hay un documento, se actualiza.
              toastInfo = toast.info(t('documents.savingData'), { autoClose: false });
              createDeclRes(el.files[0], nifProv, result.value.data)
                .then((res) => {
                  toast.update(toastInfo, {
                    render: t('documents.fileUploadedSuccess'),
                    type: toast.TYPE.SUCCESS,
                    autoClose: true,
                  });
                  resolve(true);
                })
                .catch((err) => {
                  toast.update(toastInfo, {
                    render: t('documents.fileUploadError'),
                    type: toast.TYPE.ERROR,
                    autoClose: true,
                  });
                });
            } else {
              updateDeclRes(el.files[0], idDeclRes)
                .then((res) => {
                  toast.update(toastInfo, {
                    render: t('documents.fileUpdatedSuccess'),
                    type: toast.TYPE.SUCCESS,
                    autoClose: true,
                  });
                  resolve(true);
                })
                .catch((err) => {
                  console.log(err);
                  toast.update(toastInfo, {
                    render: t('documents.fileUpdateError'),
                    type: toast.TYPE.ERROR,
                    autoClose: true,
                  });
                });
            }
          };
        }
      });
    } catch (error) {
      // En caso de error, rechaza la promesa
      reject(error);
    }
  });
};

export const validarDeclRes = (ruta, id, nifAAFF) => {
  // const toastInfo = toast.info()
  return new Promise(async (resolve, reject) => {
    try {
      const toastInfo = toast.info();
      abrirArchivo(ruta);
      Swal.fire({
        title: t('documents.whatDoYouWant'),
        text: " " + t('documents.notValidatedWarning'),
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: t('documents.validate'),
        confirmButtonColor: "#7bc977",
        denyButtonText: t('documents.notValidate'),
        denyButtonColor: "#FF5252",
        cancelButtonText: t('actions.cancel'),
        customClass: {
          actions: "my-actions",
          confirmButton: "order-3",
          denyButton: "order-2",
        },
        focusConfirm: false,
      }).then((result) => {
        if (result.isConfirmed) {
          validateDeclRes(nifAAFF, id, { validate: true })
            .then((res) => {
              toast.update(toastInfo, {
                render: t('documents.fileValidatedSuccess'),
                type: toast.TYPE.SUCCESS,
                autoClose: true,
              });
              resolve(true);
            })
            .catch((err) => {
              console.log(err);
              toast.update(toastInfo, {
                render: t('documents.fileValidationError'),
                type: toast.TYPE.ERROR,
                autoClose: true,
              });
            });
        } else if (result.isDenied) {
          validateDeclRes(nifAAFF, id, { validate: false })
            .then((res) => {
              resolve(true);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    } catch (error) {
      reject(error);
    }
  });
};

export const verDeclRes = (nifProv, idAAFF, nifAAFF, ruta, idDeclRes) => {
  // creamos todo dentro de un promise para que cuando acaben las funciones se actualice la info en la vista sin necesidad de recargar pagina
  return new Promise(async (resolve, reject) => {
    try {
      // await new Promise((resolve) => setTimeout(resolve, 200));
      Swal.fire({
        title: t('documents.whatDoYouWant'),
        text: " " + t('documents.overwriteWarning'),
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: t('actions.view'),
        confirmButtonColor: "rgb(130, 130, 130)",
        denyButtonText: t('documents.overwrite'),
        denyButtonColor: "rgb(130, 130, 130)",
        cancelButtonText: t('documents.deleteDocument'),
        cancelButtonColor: "#892828",
        customClass: {
          actions: "my-actions",
          cancelButton: "order-1 right-gap",
          confirmButton: "order-3",
          denyButton: "order-2",
        },
        focusConfirm: false,
      }).then((result) => {
        if (result.isConfirmed) {
          abrirArchivo(ruta);
        } else if (result.isDenied) {
          const subirDocPromise = subirDeclaracionResponsable(
            nifProv,
            idAAFF,
            ruta,
            idDeclRes
          );
          subirDocPromise.then(resolve).catch(reject); //esperar a ejecutar la funcion para enviar la promesa
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          // const deleteDocPromise = deleteDocsSupp(nifAAFF, id)
          const deleteDocPromise = validateDeclRes(nifAAFF, idDeclRes, {
            validado: false,
          });
          deleteDocPromise
            .then(resolve)
            .then(toast.success(t('documents.documentDeletedSuccess')))
            .catch(reject);
        }
      });
    } catch (error) {
      // En caso de error, rechaza la promesa
      reject(error);
    }
  });
};
